import { Component, Inject, OnInit } from "@angular/core";
import { Form, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { WebhookField } from "../webhook-interfaces/configuration";
import { HTTPService } from "src/app/services/http.service";
import { ObjectUtil } from "src/app/system-utils/utils/ObjectUtil";
import { NzMessageService } from "ng-zorro-antd/message";
import { LanguageService } from "typescript";
import { LanguageServices } from "src/app/services/LanguageServices";
import { FormServices } from "src/app/services/form.services";
import { CronFormComponent } from "src/app/forms/cron-form/cron-form.component";
import { WebHookCommonServices } from "../webhook-services/webhook-commom.services";
import { NZ_MODAL_DATA, NzModalService } from "ng-zorro-antd/modal";
import { WebhookMultipleContextComponent } from "../webhook-multiple-context/webhook-multiple-context.component";

@Component({
    selector: 'webhook-new-item',
    templateUrl: './webhook-new-item.component.html',
    styleUrls: ['./webhook-new-item.component.scss'],
    standalone: false
})

export class WebhookNewItemComponent implements OnInit {
    sub3: any;
    preferences:string = 'use.experimental.formula.conf;experimental.header.split;use.new.recursivexml;use.experimental.formula.with.doretry;mktplace.remove.start.end.quotes.on.split;mktp.use.new.regex.function.discovery.idconf';

    changeContext(event){
        
        if ( event ){
            this.form.get('CODECOMPANY').clearValidators();
            this.form.get('CODECOMPANY').updateValueAndValidity();
            this.form.get('SCHEDULE').clearValidators();
            this.form.get('SCHEDULE').updateValueAndValidity();
            this.form.get('CODECOMPANY').setValue(0)
            this.form.updateValueAndValidity();
        }else{
            this.form.get('CODECOMPANY').setValidators([Validators.required]);
            this.form.get('SCHEDULE').setValidators([Validators.required]);
            this.form.get('CODECOMPANY').setValue(null);
            this.form.updateValueAndValidity();
        }
    }

    cronComponent:CronFormComponent = new CronFormComponent(null,null,null);
    multipleContext:boolean = false;

    async openContextModal(){

        if ( this.form.get('IDCONF').value == null || this.form.get('IDCONF').value=='' ){
            await this.save();
        }

        this.modalServices.create({
            nzTitle: this.ls.instant('workflow.context.title'),
            nzContent: WebhookMultipleContextComponent,
            nzData: {
                editItem: this.form.value,
                fields: this.fields,
                preferences: this.preferences
            },
            nzStyle: { top: '5px', maxHeight: '90vh', display: 'flex','flex-direction': 'column' },
            nzBodyStyle: { overflow: 'auto',  display: 'flex','flex-direction': 'column', height: '100%' },
            nzWidth: '70%',
            nzOnOk: (component) => {
                return new Promise((resolve, reject) => {
                    
                    if ( component.editingContext == null){
                        return resolve(true);
                    }else{
                        this.message.error(this.ls.instant('workflow.context.edit.alert'));
                        resolve(false);
                    }
                }).catch(error=>{
                    return Promise.reject();
                });

            }
        })
    }

    save() {


      return new Promise((resolve, reject) => {
            
            if (this.form.invalid) {
                this.webhookServices.showError(this.fields,this.form);
                reject();
                return;
            }      

            let ob = {
                entityName: 'Mktpcfg',
                IDCONF: this.form.value.IDCONF,
                NAME: this.form.value.NAME,
                CODECOMPANY: this.form.value.CODECOMPANY,
                CODEMKTP: this.form.value.CODEMKTP,
                CODEMKTPDEST: this.form.value.CODEMKTPDEST,
                ENVIRONMENT: this.form.value.ENVIRONMENT,
                SCHEDULE: this.form.value.SCHEDULE,
                ACTIVE:"N",
                NEWMODE: 'S',
                PREFERENCES:this.preferences
            }

            this.sub3 = this.http.post(ob,'JsonBrokerServices/save',false).subscribe({
                next: (data:any) => {
                    
                    if ( ObjectUtil.isNotEmpty(data)){
                        if ( this.form.get('IDCONF').value == null || this.form.get('IDCONF').value  == '' ){        
                            
                            this.form.get('IDCONF').patchValue(data['IDCONF']);
                            this.message.success(this.ls.instant('workflow.success.created'));
                        }else{
                            this.message.success(this.ls.instant('workflow.success.updated'));
                        }
                        resolve(data);
                    }else{
                        resolve(false);
                    }
                },
                error: (error:any) => {
                    reject(error);
                }
            });
        });
    }
    form: FormGroup;
    
    get codecompany(): WebhookField {
        return this.fields.find(field => field.field === 'CODECOMPANY');
    }
    get name(): WebhookField {
        return this.fields.find(field => field.field === 'NAME');   
    }
    get codemktp(): WebhookField {
        return this.fields.find(field => field.field === 'CODEMKTP');
    }

    get codemktpdest(): WebhookField {
        return this.fields.find(field => field.field === 'CODEMKTPDEST');
    }

    get environment(): WebhookField {
        return this.fields.find(field => field.field === 'ENVIRONMENT');    
    }
    get schedule(): WebhookField {
        return this.fields.find(field => field.field === 'SCHEDULE');    
    }

    fields:WebhookField[] = [];
        
    onSubmit() {
        throw new Error('Method not implemented.');
    }

    constructor(
        private fb: FormBuilder, 
        private http:HTTPService, 
        private message: NzMessageService, 
        private ls:LanguageServices,
        private fs:FormServices, 
        private webhookServices:WebHookCommonServices,  
        @Inject(NZ_MODAL_DATA) public nzData,
        private modalServices:NzModalService
    ) { 
           this.form = this.fb.group({
            IDCONF:[null],
            CODECOMPANY:['0',Validators.required],
            NAME:['',Validators.required],
            CODEMKTP:['',Validators.required],
            CODEMKTPDEST:['',Validators.required],
            ENVIRONMENT:[null], 
            SCHEDULE:[null],
            PREFERENCES:[this.preferences]
        });
    }
    
    
    ngOnInit(): void {
        
        this.multipleContext = true;

        if ( this.nzData!= null && this.nzData.editItem != null ){
            this.fs.patchForm(this.nzData.editItem,this.form);
            
            // if ( this.form.get('CODECOMPANY').value == 0 ){
            //     this.multipleContext = true;
            //     this.changeContext(true);
            // }
        }

        this.fields = [{
                field:"CODECOMPANY",
                type:"search",
                label:"codecompany",
                placeholder:"codecompany",  
                searchProperties: {
                    entityName: 'Mktpcompanies',
                    fields: {
                        keyField: 'CODECOMPANY',
                        valueField: 'NAME'
                    }
                },
                showKey: true
            },
            {
                field:"NAME",
                type:"text",
                label:"name",
                placeholder:"name"
            },
            {
                field:"CODEMKTP",
                type:"search",
                label:"codemktp",
                placeholder:"codemktp",  
                searchProperties: {
                    entityName: 'Mktplaces',
                    fields: {
                        keyField: 'CODEMKTP',
                        valueField: 'NAME'
                    }
                },
                showKey: true
            },
             {
                field:"CODEMKTPDEST",
                type:"search",
                label:"codemktpdest",
                placeholder:"codemktpdest",  
                searchProperties: {
                    entityName: 'Mktplaces',
                    fields: {
                        keyField: 'CODEMKTP',
                        valueField: 'NAME'
                    }
                },
                showKey: true
            },
            {
                field:"ENVIRONMENT",
                type:"select",
                label:"environment",
                placeholder:"environment",
                options: [
                    {
                        "value": 1,
                        "label": "workflow.environment.production"
                    },
                    {
                        "value": 2,
                        "label": "workflow.environment.homologation"
                    }
                ]
            },
            {
                field:"SCHEDULE",
                type:"text",
                label:"schedule",
                placeholder:"schedule",
                isDisabled: true,
                action: {
                    component: 'CronFormComponent',
                    title: this.ls.instant('workflow.schedule.title'),
                    width: '80%',
                    icon: 'schedule',
                    okText: this.ls.instant('workflow.schedule.ok'),
                    cancelText: this.ls.instant('workflow.schedule.cancel'),
                    data: {
                        showButtons:false,
                        value: this.form.get("SCHEDULE").value
                    },
                    onOk: {eventName:null,function: (component) => {
                        if (component.cronForm.value != '') {
                            this.form.patchValue({ SCHEDULE: component.cronForm.value });
                        }
                        return Promise.resolve();
                    }
                    },
                    onCancel:{eventName:null, function: () => {
                        return Promise.resolve();
                        }
                    }
                }
            }
        ]

    }

}